import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { computeCanAccessRoute } from 'Includes/routePermissionAccess';

/**
 * Matches sidebar permission rules so deep links cannot open screens the menu hides.
 */
function PermissionRouteBoundary() {
  const { pathname } = useLocation();

  const allowed = React.useMemo(() => computeCanAccessRoute(pathname), [pathname]);

  if (!allowed) {
    return (
      <Box sx={{ p: 4, textAlign: 'center', mt: 10 }}>
        <Typography variant="h4" color="error" fontWeight="bold" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary">
          You don't have permission to view this page.
        </Typography>
      </Box>
    );
  }
  return <Outlet />;
}

export default PermissionRouteBoundary;
